// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleSegment_container__gHlvK","infos":"SingleSegment_infos__kiy_M","inner":"SingleSegment_inner__1HEN0","infoWrapper":"SingleSegment_infoWrapper__OnoLX"};